import React from 'react';
import { LoginDialog } from '../Auth';
import DeleteDialog from './DeleteDialog';
import ErrorModal from './ErrorModal';
import ProgressModal from './ProgressModal';
import GlobalCopyProgressModal from './GlobalCopyProgressModal';

const ModalContainer = ({
  // LoginDialog props
  loginDialogOpen,
  setLoginDialogOpen,
  isSignup,
  setIsSignup,
  email,
  setEmail,
  password,
  setPassword,
  handleEmailAuth,
  handleGoogleAuth,
  handleKakaoAuth,
  
  // DeleteDialog props
  deleteDialogOpen,
  setDeleteDialogOpen,
  handleDeleteConfirm,
  history,
  deleteTargetId,
  
  // ErrorModal props
  errorModalOpen,
  closeErrorModal,
  errorType,
  handleRetry,
  errorMessage,
  
  // ProgressModal props
  progressModal,
  handleAnalysisCancel,
  visualProgress,
  
  // GlobalCopyProgressModal props
  globalCopyModal,
  closeGlobalCopyModal,
  
}) => {
  return (
    <>
      <LoginDialog
        open={loginDialogOpen}
        onClose={() => setLoginDialogOpen(false)}
        isSignup={isSignup}
        setIsSignup={setIsSignup}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        handleEmailAuth={handleEmailAuth}
        handleGoogleAuth={handleGoogleAuth}
        handleKakaoAuth={handleKakaoAuth}
      />

      <DeleteDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={handleDeleteConfirm}
        title={history.find(h => h.id === deleteTargetId)?.title || ''}
      />

      <ErrorModal
        open={errorModalOpen}
        onClose={closeErrorModal}
        errorType={errorType}
        onRetry={handleRetry}
        customMessage={errorMessage}
      />

      <ProgressModal
        open={progressModal.open}
        currentStep={progressModal.currentStep}
        percentage={progressModal.progress}
        currentMessage={progressModal.currentMessage}
        estimatedRemainingTime={progressModal.estimatedRemainingTime}
        videoDuration={progressModal.videoDuration}
        onCancel={progressModal.onCancel}
        progressData={progressModal}
        visualProgress={visualProgress}
        userId={progressModal.userId}
        historyId={progressModal.historyId}
      />

      <GlobalCopyProgressModal
        open={globalCopyModal.open}
        videoTitle={globalCopyModal.videoTitle}
        onComplete={closeGlobalCopyModal}
      />
    </>
  );
};

export default ModalContainer; 